import * as yup from 'yup';

const requiredText = (label) =>
  yup.string().trim().required(`${label} is required`);

const phoneNumber = (label) =>
  yup
    .string()
    .trim()
    .required(`${label} is required`)
    .matches(/^\+\d{8,15}$/, `${label} must include a country and 8 to 15 digits`);

export const userProfileSchema = yup.object().shape({
  firstname: requiredText('First name'),
  lastname: requiredText('Family name'),
  title: requiredText('Title'),
  gender: yup
    .string()
    .oneOf(['male', 'female'], 'Honorific is required')
    .required('Honorific is required'),
  phone: phoneNumber('Work phone'),
  cell_phone: phoneNumber('Cellphone'),
  fax: yup.string().nullable(),
  email: yup
    .string()
    .trim()
    .email('Email must be valid')
    .required('Email is required'),
  company_name: requiredText('Company'),
  company_location: requiredText('Address'),
  avatar: yup.string().nullable(),
});

const inputValue = (value) => (value == null ? '' : String(value));

export const getEditableUserProfile = (user = {}) => ({
  firstname: inputValue(user.firstname),
  lastname: inputValue(user.lastname),
  title: inputValue(user.title),
  gender: inputValue(user.gender),
  phone: inputValue(user.phone),
  cell_phone: inputValue(user.cell_phone),
  fax: inputValue(user.fax),
  email: inputValue(user.email),
  company_name: inputValue(user.company_name),
  company_location: inputValue(user.company_location),
  avatar: user.avatar ?? null,
});

export const getPasswordValidation = ({
  currentPassword = '',
  newPassword = '',
  confirmPassword = '',
} = {}) => {
  const checks = {
    hasMinimumLength: newPassword.length >= 6,
    hasUpperCase: /[A-Z]/.test(newPassword),
    hasNumber: /\d/.test(newPassword),
  };

  return {
    ...checks,
    passwordsMatch: newPassword === confirmPassword,
    hasCurrentPassword: currentPassword.length > 0,
    isValid:
      checks.hasMinimumLength &&
      checks.hasUpperCase &&
      checks.hasNumber &&
      newPassword === confirmPassword &&
      currentPassword.length > 0,
  };
};

export const describeProfileSaveError = (error) =>
  error?.code === 'ORGANIZATION_NOT_EXISTS'
    ? 'Wrong company name. Please try again.'
    : error?.message || 'Something went wrong. Please try again.';
